import { useCallback, useContext } from "react";
import { AccessControlContext } from "../../access-control-context";

export const useBusinessOperations = () => {
  const accessControlContext = useContext(AccessControlContext);

  const { businessOperations } = accessControlContext;

  const hasBusinessOperation = useCallback(
    (businessOperation: string) =>
      !businessOperations || businessOperations.includes(businessOperation),
    [businessOperations]
  );

  const hasBusinessOperationThatContains = useCallback(
    (name: string) =>
      !businessOperations ||
      businessOperations.some((businessOperation) =>
        businessOperation.includes(name)
      ),
    [businessOperations]
  );

  const hasAnyBusinessOperation = useCallback(
    (targetBusinessOperations: string[]) =>
      !businessOperations ||
      targetBusinessOperations.some((targetBusinessOperation) =>
        businessOperations.includes(targetBusinessOperation)
      ),
    [businessOperations]
  );

  return {
    hasBusinessOperation,
    hasAnyBusinessOperation,
    hasBusinessOperationThatContains,
  };
};
